import {
  addMobileAuthMessageListener,
  hasMobileBridge,
  isMobileAuthMode,
} from "../mobileAuthBridge";

import { postMobileMessage } from "../utils/postMobileMessage";

const SCALE_PROPERTY = "--mg-native-font-scale";
let disposeBridge;

export function installMobileFontScaleBridge() {
  if (disposeBridge) return disposeBridge;

  if (!isMobileAuthMode() || !hasMobileBridge()) return () => {};

  const root = document.documentElement;
  const previousScale = root.style.getPropertyValue(SCALE_PROPERTY);
  const previousPriority = root.style.getPropertyPriority(SCALE_PROPERTY);

  const applyScale = (scale) => {
    if (typeof scale !== "number" || !Number.isFinite(scale) || scale <= 0) return;

    const value = String(scale);

    if (root.style.getPropertyValue(SCALE_PROPERTY) !== value) {
      root.style.setProperty(SCALE_PROPERTY, value);
    }
  };

  const removeListener = addMobileAuthMessageListener((message) => {
    if (message.type === "FONT_SCALE_UPDATED") applyScale(message.fontScale);
  });

  applyScale(window.__MY_MONTEPIO_FONT_SCALE__);
  postMobileMessage("FONT_SCALE_REQUEST");

  disposeBridge = () => {
    removeListener();

    if (previousScale) root.style.setProperty(SCALE_PROPERTY, previousScale, previousPriority);
    else root.style.removeProperty(SCALE_PROPERTY);

    disposeBridge = undefined;
  };

  return disposeBridge;
}
